import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid || status === "paid" || tries > 8) return;
    const t = setTimeout(() => {
      api.get(`/payments/status/${sid}`).then(r => { setStatus(r.data.payment_status); setTries(x=>x+1); });
    }, 1500);
    return () => clearTimeout(t);
  }, [sid, status, tries]);
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-[#F4F4F7]">
      <div className="ic-card p-10 text-center max-w-md">
        <Link to="/" className="text-sm text-[#5424D5] font-semibold">← ImpresaChiara</Link>
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-[#10B981] mx-auto mt-6" />
            <h1 className="text-2xl font-bold mt-4" data-testid="payment-success-title">Pagamento confermato</h1>
            <p className="text-[#524F5E] mt-2">Grazie! Il tuo piano è ora attivo.</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 border-4 border-[#5424D5]/20 border-t-[#5424D5] rounded-full animate-spin mx-auto mt-6" />
            <h1 className="text-2xl font-bold mt-4">Attendiamo la conferma…</h1>
            <p className="text-[#524F5E] mt-2 text-sm">Tentativo {tries+1}/9</p>
          </>
        )}
        <Link to="/dashboard" className="ic-btn-primary inline-block mt-6">Vai al cruscotto</Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-[#F4F4F7]">
      <div className="ic-card p-10 text-center max-w-md">
        <XCircle className="w-16 h-16 text-[#FF6A24] mx-auto" />
        <h1 className="text-2xl font-bold mt-4">Pagamento annullato</h1>
        <p className="text-[#524F5E] mt-2">Nessun addebito effettuato.</p>
        <Link to="/pricing" className="ic-btn-primary inline-block mt-6">Torna ai piani</Link>
      </div>
    </div>
  );
}
